export default {
  large: [

    {
      sectionType: 'subsections',

      data: {
        color: 'offBlackOnSand',
        sections: [
          {
            full: {
              component: 'flex-block',
              data: {
                blockModifiers: ['endMargin','alignCenter'],
                headerSize: 'large',
                header1: 'Bag&nbsp;&&nbsp;Checkout<br>-&nbsp;Anywhere',
                text1: "<p>Spotin's built in shoppingbag, payment integrations, checkout and order integration solutions can be used for a variety of commerce services.</p><p>Sell at events (with/without preorder), create your own applications, or Spotin's Checkout from Shelf retail concept.</p>",
                component3: {
                  type: 'animation',
                  data: {
                    loop: true,
                    autoplay: true,
                    // blockModifiers: ['endMargin'],
                    blockModifiers: ['bringToFront','350px','mobileOffSetMinus50'],
                    src: "Bag_checkout.json",
                  }
                }
              },
            },
          }
        ]
      },
    },

    {
      sectionType: 'subsections',

      data: {
        color: 'offWhiteOnBlue',
        sections: [
          {
            full: {
              component: 'flex-block',
              data: {
                blockModifiers: ['endMargin','alignCenter'],
                // mobileHeaderTop: true,
                component1: {
                  type: 'animation',
                  data: {
                    // blockModifiers: ['smallBottomMargin'],
                    loop: true,
                    autoplay: true,
                    animationSpeed: 0.1,
                    src: "Flying_box.json",
                  }
                },
                header2: '"Phygital"',
                text2: "<p>With Spotin\'s shoppingbag you can easily extend your digital sales to physical retail. Easily sell products at events and tradeshows, or connect your digital sales with printed or digital ads.</p><p>Spotin's \"phygital\" bag and checkout is also perfect to use together with the build-in pre-oder and backorder features, e.g. for selling made-to-order or print-on-demand products.</p><p>There are numerous ways to connect your shoppingbag with Spotin and physical sales. Allow adding product to your bag with QR-codes/links, Spotin's UI or with your own buttons.",
              }
            },
          }
        ]
      },
    },

    // {
    //   sectionType: 'subsections',

    //   data: {
    //     color: 'offBlackOnOffWhite',
    //     sections: [
    //       {
    //         full: {
    //           component: 'flex-block',
    //           data: {
    //             blockModifiers: ['endMargin','alignTop'],
    //             text1: "<p>More information coming soon...</p>",
    //           },
    //         },
    //       }
    //     ]
    //   },
    // },


    {
      sectionType: 'subsections',

      data: {
        color: 'offBlackOnOffWhite',
        sections: [
          {
            full: {
              component: 'flex-block',
              data: {
                blockModifiers: ['endMargin','alignCenter'],
                columns: 3,
                header1: 'Checkout-from-shelf',
                text1: `
                  <p>A new retail experience that combines the best of two worlds.</p>
                  <p>Brand's can further increase their sales reach, create a better in-store experiences and branding and reduce returns.</p>
                  <p>Customers can see, feel and try the products in store but are not limited to the store's own stock. Complete purchase from one or many stores with one order - in store, at the café or at home. Your order is delivered directly to home so no more bags to carry around.</p>
                  <p>Stores and showrooms can easily be setup at low cost and with little risk and since the store don't keep products in stock. Compete with a better in-store experience - where the store no longer look like a wardrobe.</p>
                  `,
                img3: {
                  src: 'chechout_from_shelf.png',
                  alt: 'Checkout-from-shelf',
                },
              },
            },
          }
        ]
      },
    },


    {
      sectionType: 'subsections',

      data: {
        color: 'offWhiteOnOffBlack',
        sections: [
          {
            full: {
              component: 'flex-block',
              data: {
                // blockModifiers: ['endMargin'],
                header1: 'Enterprise solutions',
                text2: `<p>Spotin is a versatile platform. If your company has an idea of an application, service or campaign where you want to add commerce - then Spotin is the complete solution to fill your needs.</p><p>Product imports, shoppingbag, payment integrations (e.g. with VAT and currency conversion built in), checkout, and ability to integrate with your or 3<sup>rd</sup> party order management systems and accounting systems.</p><p>Get in touch with <a href="mailto: marketing@spotin.com?subject=Enterprise solutions with Spotin" style="text-decoration: underline;">Spotin\'s marketing team</a> to know more about Spotin\'s enterprise solutions.</p>`,
              }
            },
          }
        ]
      },
    },


    // {
    //   sectionType: 'subsections',

    //   data: {
    //     color: 'offWhiteOnOffBlack',
    //     sections: [
    //       {
    //         full: {
    //           component: 'flex-block',
    //           data: {
    //             blockModifiers: ['endMargin','alignTop'],
    //             header1: 'Use-case: Creator Studio',
    //             text1: "<p>TBD</p>",

    //             // component3: {
    //             //   type: 'animation',
    //             //   data: {
    //             //     loop: true,
    //             //     autoplay: true,
    //             //     // blockModifiers: ['endMargin'],
    //             //     blockModifiers: ['bringToFront','350px','mobileOffSetMinus50'],
    //             //     src: "ShopScroll.json",
    //             //   }
    //             // }
    //           },
    //         },
    //       }
    //     ]
    //   },
    // },


    {
      sectionType: 'subsections',

      data: {
        color: 'offWhiteOnOffBlack',
        sections: [
          {
            top: {
              component: 'flex-block',
              data: {
                header1: 'Other products & solutions'
              }
            },
            bottom: {
              component: 'Related',
              data: {
                buttons: [
                  {
                    icon: 'arrowUpRight',
                    label: 'In-content commerce',
                    blockModifiers: ['alignLabelLeft', 'alignLabelTop'],
                    path: 'incontent',
                  },
                  {
                    icon: 'arrowUpRight',
                    label: 'Virtual marketplace',
                    blockModifiers: ['alignLabelLeft', 'alignLabelTop'],
                    path: 'shop',
                  }
                ],
              }
            }
          }
        ]
      },
    },

  ],
};



// WEBPACK FOOTER //
// ./pages/Checkout.js